import { HttpError } from '../api/http-error';

export enum ApiError {
  Unauthorized = 'Unauthorized',
  Not_Found = 'Not Found',
  Conflict = 'Conflict',
  Session_Not_Ready = 'Session Not Ready',
  Other = 'Other',
}

export const parseApiError = (error: unknown): ApiError => {
  const status = error instanceof HttpError
    ? error.status
    : error && typeof error === 'object' && 'status' in error
      ? (error as { status: number }).status
      : null;

  switch (status) {
    case 401:
    case 403:
      return ApiError.Unauthorized;
    case 404:
      return ApiError.Not_Found;
    case 409:
      return ApiError.Conflict;
    default:
      return ApiError.Other;
  }
};
